import { apiClient } from "../../../lib";
import { FilterItem } from "../../../shared/context/FilterContext";
import { extractFilterValues } from "../../../lib/filterUtils";

export interface RiskFilterParams {
    projectId?: string;
    searchKey?: string;
    assignedToMe?: boolean;
    quickFilters?: any;
    status?: string;
    category?: string;
    impactScore?: string;
    probabilityScore?: string;
}

const buildRiskFilterParams = ({ projectId, searchKey, assignedToMe, quickFilters, status, category, impactScore, probabilityScore }: RiskFilterParams): URLSearchParams => {
    const params = {
        project_id: projectId,
        search_term: searchKey,
        assign_to_me: assignedToMe,
        workstream_id: extractFilterValues(quickFilters?.workstream) || null,
        site_id: extractFilterValues(quickFilters?.site) || null,
        programme_id: extractFilterValues(quickFilters?.programme) || null,
        region_id: extractFilterValues(quickFilters?.region) || null,
        work_type_group_id: extractFilterValues(quickFilters?.['worktype-group']) || null,
        project_year: extractFilterValues(quickFilters?.projectYear) || null,
        status: status || null,
        category: category || null,
        impact_score: impactScore || null,
        probability_score: probabilityScore || null,
    };
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(v => {
                if (v) searchParams.append(key, String(v));
            });
        } else if (value) {
            searchParams.append(key, String(value));
        }
    });
    return searchParams;
};

export const riskDetailsApi = {
    fetchRiskDetail: async ({ riskId }: { riskId: string | null }): Promise<any> => {
        const response = await apiClient.get(`/risks/${riskId}`);
        return response.data;
    },
    fetchRiskSummary: async (projectId?: string): Promise<any> => {
        const response = await apiClient.get(!projectId ? '/risks/summary' : `/risks/summary?project_id=${projectId}`);
        return response.data;
    },
    fetchCriticalRisks: async (filters: RiskFilterParams): Promise<any> => {
        const queryString = buildRiskFilterParams(filters).toString();
        const response = await apiClient.get(`/risks/critical-risk${queryString ? `?${queryString}` : ''}`);
        return response.data;
    },
    fetchRiskCategories: async (filters: RiskFilterParams): Promise<any> => {
        const queryString = buildRiskFilterParams(filters).toString();
        const response = await apiClient.get(`/risks/risk-categories${queryString ? `?${queryString}` : ''}`);
        return response.data;
    },
    fetchRiskMatrix: async (filters: RiskFilterParams): Promise<any> => {
        const queryString = buildRiskFilterParams(filters).toString();
        const response = await apiClient.get(`/risks/risk-matrix${queryString ? `?${queryString}` : ''}`);
        return response.data;
    },
    fetchRiskRegister: async ({ page, limit, ...filters }: RiskFilterParams & { page: number, limit: number }): Promise<any> => {
        const searchParams = buildRiskFilterParams(filters);
        searchParams.append('page', String(page));
        searchParams.append('limit', String(limit));
        const response = await apiClient.get(`/risks/risk-register?${searchParams.toString()}`);
        return response.data;
    },
};